import Vue from 'vue';
import Vuex from 'vuex';
import app from './app';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    ndc: {
      namespaced: true,
      state: {
        loadedModules: [],
        queuedModules: [],
      },
      mutations: {
        setValue(state, data) {
          state[data.key] = data.value;
        },
        setQueuedValue(state, data) {
          const index = state.queuedModules.findIndex((n) => data.name === n.name);

          if (index !== -1) {
            state.queuedModules[index] = data;
          } else {
            state.queuedModules = [
              ...state.queuedModules,
              data,
            ];
          }
        },
        removeQueuedValue(state, name) {
          state.queuedModules = [...state.queuedModules]
            .filter((n) => n.name !== name);
        },
      },
      modules: {
        app,
      },
    },
  },
});
